import { CHANGE_THEME } from "@stores/actions/action_types";
import { rootInitialState, rootReducer } from "@stores/reducers";
import AppContext from "@utils/context";
import { flashPreviewForSettingKeys } from "@libs/previewSettingFlash";
import React, { useMemo, useCallback, useRef } from "react";

const StoreProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = React.useReducer(rootReducer, rootInitialState);
  const stateRef = useRef(state);
  stateRef.current = state;

  /**
   * Mọi `change_theme()` đều đi qua đây: sau khi merge settings, flash preview theo key vừa đổi
   * (áp dụng toàn app theme builder, không cần gọi từ từng hook form).
   */
  const enhancedDispatch = useCallback((action: any) => {
    if (
      action?.type === CHANGE_THEME &&
      action.theme?.settings &&
      typeof action.theme.settings === "object"
    ) {
      const prevSettings =
        stateRef.current.ThemesReducer?.theme?.settings ?? {};
      const patch = action.theme.settings as Record<string, unknown>;
      const changedKeys = Object.keys(patch).filter(
        (k) =>
          JSON.stringify(prevSettings[k as keyof typeof prevSettings]) !==
          JSON.stringify(patch[k])
      );
      dispatch(action);
      if (changedKeys.length > 0) {
        queueMicrotask(() => {
          flashPreviewForSettingKeys(changedKeys, { delayMs: 0 });
        });
      }
      return;
    }
    dispatch(action);
  }, [dispatch]);

  // Memoize the store value with enhanced dispatch
  const store = useMemo(() => [state, enhancedDispatch] as const, [state, enhancedDispatch]);

  return <AppContext.Provider value={store}> {children} </AppContext.Provider>
}

export default StoreProvider
